"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var numeral = require('numeral');
var convert = require('convert-units');
var LocalUnitRender = /** @class */ (function (_super) {
    __extends(LocalUnitRender, _super);
    function LocalUnitRender() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.genUnits = function () {
            var _a = _this.props, value = _a.value, defaultUnit = _a.defaultUnit, metricUnit = _a.metricUnit, imperialUnit = _a.imperialUnit, context = _a.context, showAbbreviation = _a.showAbbreviation, decimalPlaces = _a.decimalPlaces;
            var con = _this.genContext(context);
            var rawValue;
            if (con === 'm') {
                rawValue = convert(value).from(defaultUnit).to(metricUnit);
            }
            else if (con === 'i') {
                rawValue = convert(value).from(defaultUnit).to(imperialUnit);
            }
            else {
                rawValue = value;
            }
            if (showAbbreviation) {
                var formatString = '0.';
                if (decimalPlaces) {
                    formatString += '0'.repeat(decimalPlaces);
                }
                formatString += 'a';
                return numeral(rawValue).format(formatString).toUpperCase() + _this.genLabel(context);
            }
            return _this.setDecimalPlaces(rawValue) + _this.genLabel(context);
        };
        _this.setDecimalPlaces = function (value) {
            var decimalPlaces = _this.props.decimalPlaces;
            var multiplier = Math.pow(10, decimalPlaces);
            return (Math.round(value * multiplier) / multiplier);
        };
        _this.genLabel = function (context) {
            var _a = _this.props, defaultUnit = _a.defaultUnit, showUnits = _a.showUnits, metricUnit = _a.metricUnit, imperialUnit = _a.imperialUnit;
            if (showUnits) {
                var con = _this.genContext(context);
                var unit = convert().describe(defaultUnit);
                if (con === 'm') {
                    unit = convert().describe(metricUnit);
                }
                else if (con === 'i') {
                    unit = convert().describe(imperialUnit);
                }
                return '\xa0' + _this.SIUnit(unit.abbr);
            }
            else {
                return '';
            }
        };
        _this.SIUnit = function (textUnit) {
            switch (textUnit) {
                case 'C':
                    return '°C';
                case 'F':
                    return '°F';
                case 'R':
                    return '°R';
                default:
                    return textUnit.replace('2', '²').replace('3', '³');
            }
        };
        _this.genContext = function (context) {
            var _a = _this.props, metricUnit = _a.metricUnit, imperialUnit = _a.imperialUnit;
            var units = context.measurementUnits;
            if (units) {
                if (units === 'metric' && metricUnit) {
                    return 'm';
                }
                else if (units === 'imperial' && imperialUnit) {
                    return 'i';
                }
            }
            return 'd';
        };
        return _this;
    }
    LocalUnitRender.prototype.render = function () {
        return this.genUnits();
    };
    return LocalUnitRender;
}(react_1.Component));
exports.default = LocalUnitRender;
